import styled from 'styled-components'
import media from 'styled-media-query'

export const Grid = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  height: auto;
  transition: all ease 0.3s;

  ${media.lessThan('medium')`
    display: flex;
    flex-direction: column;
  `}

  ${media.between('medium', 'large')`
    display: flex;
    flex-direction: row;
  `}

  ${media.greaterThan('large')`
    display: flex;
    flex-direction: row;
  `}
`

export const Wrapper = styled.div`
  width: 100%;
  overflow: auto;
  padding: 2rem;
  padding-bottom: 0;
  transition: all ease 0.3s;

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  ${media.lessThan('medium')`
    width: 100%;
    padding: 1.5rem;
  `}

  ${media.between('medium', 'large')`
    width: 100%;
  `}

  ${media.greaterThan('large')`
    width: 100%;
  `}
`

export const Cart = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 450px;
  height: 100vh;
  background: #fdfdfa;
  overflow: none;
  transition: all ease 0.3s;
  box-shadow: -5px 0 25px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1100;

  ul {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding: 25px;
    margin: 0;
    list-style: none;

    li {
      margin-left: 15px;

      .btn-currency {
        padding: 5px 10px;
        border-radius: 4px;
        margin-right: 4px;
        background: rgba(0, 0, 0, 0.1);
        font-size: 12px;
        cursor: pointer;
        transition: all ease 0.3s;

        &.actived {
          background: var(--primary);
          color: #fff;
        }
      }

      &.cart-count {
        text-align: center;
        line-height: 35px;
        font-weight: bold;
        font-size: 24px;
        width: 35px;
        height: 35px;
        border-radius: 5px;
        background: var(--quaternary);
      }

      &.cart-close {
        display: block;
      }

      a {
        font-size: 32px;
        color: #212121;
      }
    }
  }

  h3 {
    font-size: 26px;
    line-height: 28px;
    padding: 0 25px;
    margin-bottom: auto;
  }

  section {
    margin-bottom: auto;
    padding: 0 30px;
    max-height: 250px;
    overflow-y: auto;

    ::-webkit-scrollbar {
      width: 5px;
    }

    ::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    ::-webkit-scrollbar-thumb {
      background: #888;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }

  button {
    position: relative;
    width: 100%;
    background: var(--primary);
    padding: 20px;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    color: #fff;
    font-weight: 600;
    text-align: left;

    &:focus {
      outline: none;
    }

    &:disabled {
      background: #616161;
    }

    svg {
      position: absolute;
      top: 50%;
      right: 25px;
      transform: translateY(-50%);
      font-size: 26px;
    }
  }

  ${media.lessThan('medium')`
    width: 100%;
  `}

  ${media.between('medium', 'large')`
    width: 450px;
  `}

  ${media.greaterThan('large')`
    width: 450px;
  `}
`

export const Footer = styled.footer`
  background: linear-gradient(to right, #f8fafc, #f1f5f8);
  padding: 4rem 2rem 2rem;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  
  .footer-content {
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .footer-logo {
    margin-bottom: 2.5rem;
    text-align: center;
    
    h3 {
      font-size: 2rem;
      font-weight: 800;
      color: #17253D;
      margin-bottom: 0.5rem;
      
      span {
        background: linear-gradient(90deg, #3454D1, #0891b2);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
      }
    }
    
    .tagline {
      color: #4B5563;
      font-size: 1rem;
    }
  }
  
  .footer-section {
    margin-bottom: 2rem;
    
    h4 {
      font-size: 1.1rem;
      font-weight: 700;
      color: #17253D;
      margin-bottom: 1.2rem;
      position: relative;
      display: inline-block;
      
      &:after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 30px;
        height: 2px;
        background: linear-gradient(90deg, #3454D1, #0891b2);
      }
    }
    
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      
      li {
        margin-bottom: 0.8rem;
        
        a {
          color: #4B5563;
          text-decoration: none;
          transition: color 0.3s ease;
          font-size: 0.95rem;
          
          &:hover {
            color: #3454D1;
          }
        }
      }
    }
    
    .social-links {
      display: flex;
      gap: 1rem;
      
      a {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: white;
        color: #3454D1;
        font-size: 1.2rem;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        transition: all 0.3s ease;
        
        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
        }
      }
    }
  }
  
  .footer-bottom {
    text-align: center;
    border-top: 1px solid rgba(75, 85, 99, 0.2);
    padding-top: 2rem;
    margin-top: 2rem;
    
    .copyright {
      font-size: 0.9rem;
      color: #4B5563;
      margin-bottom: 0.5rem;
    }
    
    .disclaimer {
      font-size: 0.8rem;
      color: #6B7280;
      margin: 0;
    }
  }

  @media (max-width: 768px) {
    padding: 3rem 1.5rem 1.5rem;
    
    .footer-section {
      text-align: center;
      
      h4:after {
        left: 50%;
        transform: translateX(-50%);
      }
      
      .social-links {
        justify-content: center;
      }
    }
  }
`

export const CartToggle = styled.button`
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 110px;
  right: 17px;
  z-index: 98;
  border-radius: 50px;
  padding: 0.75rem 1.5rem;
  background: linear-gradient(90deg, #3454D1, #0891b2);
  color: white;
  font-weight: 600;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  
  span {
    margin: 0 0.5rem;
  }
  
  svg {
    font-size: 1.2rem;
  }
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  }
  
  ${media.lessThan('medium')`
    bottom: 30px;
    padding: 0.75rem 1rem;
    
    span {
      display: none;
    }
  `}
`

export const CartCount = styled.div`
  background: white;
  color: #3454D1;
  font-weight: 700;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
`

export const CartButton = styled.button`
  display: none;
  position: fixed;
  bottom: 110px;
  right: 17px;
  z-index: 98;

  border-radius: 70px;
  width: 60px;
  height: 60px;
  font-size: 32px;
  color: #fff;
  text-align: center;
  line-height: 30px;
  background: var(--primary);
  transition: all 0.2s ease-in-out 0s;

  ${media.lessThan('medium')`
    display: none;
  `}

  ${media.between('medium', 'large')`
    display: none;
  `}
`
